import React from 'react';

import powerMeterSpecs from '../../../main/assets/images/powerMeterV2/power-meter-prodcut-specs.webp';

export const Specifications = () => {
  return (
    <section className="power-meter-specs-parent">
      <div className="power-meter-specs-bg" />
      <div className="power-meter-specs">
        <div className="power-meter-specs-layout">
          <div className="power-meter-layout-first">
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">
                Calibrated Frequencies
              </h2>
              <p className="power-meter-layout-description">
                35, 72, 433, 868, 915, 1200, 2400, 5600-6000 MHz in 50MHz steps
              </p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Attenuator</h2>
              <p className="power-meter-layout-description">30dB (Internal)</p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Current Consumption</h2>
              <p className="power-meter-layout-description">~35mA</p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Auto Shutdown</h2>
              <p className="power-meter-layout-description">5-minute timeout</p>
            </div>
          </div>
          <div className="power-meter-layout-second">
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Power Level</h2>
              <p className="power-meter-layout-description">
                -20dBm up to +30dBm
              </p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Accuracy</h2>
              <p className="power-meter-layout-description">+/- 0.5dB</p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Battery</h2>
              <p className="power-meter-layout-description">
                3.7V Lithium Ion cell, 10440 size, 600mAh
              </p>
            </div>
            <div className="power-meter-layout-text">
              <h2 className="power-meter-layout-title">Battery Life</h2>
              <p className="power-meter-layout-description">~8 hours</p>
            </div>
          </div>
          <img
            src={powerMeterSpecs}
            className="power-meter-specs-img"
            alt="PowerMeter Tehnical Specifications"
          />
        </div>
      </div>
    </section>
  );
};
